import React, { useEffect } from "react";
import AdminBuilderService from '../../../API/Services/AdminService/AdminBuilderService';
import { useNavigate } from "react-router-dom";

export const AccessField = (props) => {
    const { tableName, setFieldList, manageAccessField, setManageAccessField } = props;
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem("usertoken")) {
            getAccessList();
        } else {
            navigate("/");
        }
    }, [manageAccessField]);

    const getAccessList = async () => {
        try {
            const response = await AdminBuilderService.getRoleFieldList(tableName);
            const responseData = await response.json();
            const filteredData = responseData?.filter((value) => value !== "Icon Url");
            console.log("ttt",filteredData);
            
            setFieldList(filteredData);
            setManageAccessField(false);
        } catch (error) {
            if (error.name === "HTTPError") {
                // Handle error
            }
        }
    };
};

export default AccessField;
